import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ToothUiManagerComponent} from './tooth-ui-manager.component';
import {ToothBaseComponent} from './tooth-base.component';
import {Tooth17Component} from './teeth-components/17/tooth-17.component';
import {Tooth18Component} from './teeth-components/18/tooth-18.component';
import {Tooth19Component} from './teeth-components/19/tooth-19.component';
import {Tooth20Component} from './teeth-components/20/tooth-20.component';
import {Tooth21Component} from './teeth-components/21/tooth-21.component';
import {Tooth22Component} from './teeth-components/22/tooth-22.component';
import {Tooth23Component} from './teeth-components/23/tooth-23.component';
import {Tooth24Component} from './teeth-components/24/tooth-24.component';
import {Tooth25Component} from './teeth-components/25/tooth-25.component';
import {Tooth26Component} from './teeth-components/26/tooth-26.component';
import {Tooth32Component} from './teeth-components/32/tooth-32.component';
import {Tooth31Component} from './teeth-components/31/tooth-31.component';
import {Tooth30Component} from './teeth-components/30/tooth-30.component';
import {Tooth29Component} from './teeth-components/29/tooth-29.component';
import {Tooth28Component} from './teeth-components/28/tooth-28.component';
import {Tooth27Component} from './teeth-components/27/tooth-27.component';
import {Tooth1Component} from './teeth-components/1/tooth-1.component';
import {Tooth2Component} from './teeth-components/2/tooth-2.component';
import {Tooth3Component} from './teeth-components/3/tooth-3.component';
import {Tooth4Component} from './teeth-components/4/tooth-4.component';
import {Tooth5Component} from './teeth-components/5/tooth-5.component';
import {Tooth6Component} from './teeth-components/6/tooth-6.component';
import {Tooth7Component} from './teeth-components/7/tooth-7.component';
import {Tooth8Component} from './teeth-components/8/tooth-8.component';
import {Tooth9Component} from './teeth-components/9/tooth-9.component';
import {Tooth10Component} from './teeth-components/10/tooth-10.component';
import {Tooth11Component} from './teeth-components/11/tooth-11.component';
import {Tooth12Component} from './teeth-components/12/tooth-12.component';
import {Tooth13Component} from './teeth-components/13/tooth-13.component';
import {Tooth14Component} from './teeth-components/14/tooth-14.component';
import {Tooth15Component} from './teeth-components/15/tooth-15.component';
import {Tooth16Component} from './teeth-components/16/tooth-16.component';
import {MatCheckboxModule} from '@angular/material/checkbox';



@NgModule({
  declarations: [
    ToothUiManagerComponent,
    ToothBaseComponent,
    Tooth17Component,
    Tooth18Component,
    Tooth19Component,
    Tooth20Component,
    Tooth21Component,
    Tooth22Component,
    Tooth23Component,
    Tooth24Component,
    Tooth25Component,
    Tooth26Component,
    Tooth27Component,
    Tooth28Component,
    Tooth29Component,
    Tooth30Component,
    Tooth31Component,
    Tooth32Component,
    Tooth1Component,
    Tooth2Component,
    Tooth3Component,
    Tooth4Component,
    Tooth5Component,
    Tooth6Component,
    Tooth7Component,
    Tooth8Component,
    Tooth9Component,
    Tooth10Component,
    Tooth11Component,
    Tooth12Component,
    Tooth13Component,
    Tooth14Component,
    Tooth15Component,
    Tooth16Component,
  ],
    imports: [
        CommonModule,
        MatCheckboxModule
    ],
  exports: [
    ToothUiManagerComponent,
    ToothBaseComponent,
    Tooth17Component,
    Tooth18Component,
    Tooth19Component,
    Tooth20Component,
    Tooth21Component,
    Tooth22Component,
    Tooth23Component,
    Tooth24Component,
    Tooth25Component,
    Tooth26Component,
    Tooth27Component,
    Tooth28Component,
    Tooth29Component,
    Tooth30Component,
    Tooth31Component,
    Tooth32Component,
    Tooth1Component,
    Tooth2Component,
    Tooth3Component,
    Tooth4Component,
    Tooth5Component,
    Tooth6Component,
    Tooth7Component,
    Tooth8Component,
    Tooth9Component,
    Tooth10Component,
    Tooth11Component,
    Tooth12Component,
    Tooth13Component,
    Tooth14Component,
    Tooth15Component,
    Tooth16Component,

  ]
})
export class ToothUiManagerModule { }
